import { render, staticRenderFns } from "./ShowFileInfo.vue?vue&type=template&id=5ce8ff3c&scoped=true&"
import script from "./ShowFileInfo.vue?vue&type=script&lang=js&"
export * from "./ShowFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8ff3c",
  null
  
)

export default component.exports